import { render, staticRenderFns } from "./VersionCreate.vue?vue&type=template&id=4fb3f218&scoped=true&"
import script from "./VersionCreate.vue?vue&type=script&lang=js&"
export * from "./VersionCreate.vue?vue&type=script&lang=js&"
import style0 from "./VersionCreate.vue?vue&type=style&index=0&id=4fb3f218&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb3f218",
  null
  
)

export default component.exports